<template>
    <div>
        <b-modal
            id="serial_modal"
            modal-class=""
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <!-- <div class="modal-base-close" @click="closeSerialModal()">ปิด</div> -->
                    <p id="headline">{{objSerialMessage.strHeadline}}</p>
                </div>
                <!--Show code-->
                <div class="modal-base-body">

                    <div class="img-campaign">
                        <img :src="campaign.fullImageUrl" class="img-fluid" />
                    </div>
                    <!-- <div class="content-header">ชาเนลอวยพรให้คุณมีความสุขในวันเกิด</div> -->

                    <div class="serial-block"
                        v-if="objSerialCode.isShowCode && campaign.serial">

                        <div class="serial-tab-qr">
                            <span class="qr" :class="{'tab-active': objSerialCode.strCodeType === 'QR_CODE'}">{{lblSerial.qr_code}}</span>
                        </div>
                           

                        <div id="serial_tab_wrapper" class="serial-wrapper">
                            
                            <!-- <div class="serial-tab"
                                @click="clickChangeTab('QR_CODE')">
                                    <div class="serial-tab-lbl" :class="{'tab-active': objSerialCode.strCodeType === 'QR_CODE'}">{{lblSerial.qr_code}}</div>
                                </div>
                            <div class="serial-tab"
                                @click="clickChangeTab('CODE_128')">
                                    <div class="serial-tab-lbl" :class="{'tab-active': objSerialCode.strCodeType === 'CODE_128'}">{{lblSerial.barcode}}</div>
                                </div>
                            <div class="serial-tab"
                                @click="clickChangeTab('CODE')">
                                    <div class="serial-tab-lbl" :class="{'tab-active': objSerialCode.strCodeType === 'CODE'}">{{lblSerial.code}}</div>
                                </div> -->
                        </div>
                        <div id="serial_code_wrapper"
                            class="serial-wrapper">
                             <div class="privilege-message">โปรดแสดง QR โค้ดนี้แก่พนักงาน</div>
                            <div class="serial-code"
                                v-show="objSerialCode.strCodeType === 'CODE'">
                                <p id="code"
                                    :class="{'long-code': campaign.serial.length > 12, 'serial-expire' : campaign.serial === 'XXXXXXX'}">
                                    {{campaign.serial === 'XXXXXXX' ? 'XXXXXXX' : campaign.serial}}</p>
                            </div>
                            <div class="serial-code"
                                v-show="objSerialCode.strCodeType === 'CODE_128'">
                                <vue-barcode id="barcode"
                                    :value="campaign.serial"
                                    :options="objBarcodeConfig"></vue-barcode>
                            </div>
                            <div class="serial-code"
                                v-show="objSerialCode.strCodeType === 'QR_CODE'">
                                <vue-qrcode id="qrcode"
                                    :value="campaign.serial"
                                    :options="objQrCodeConfig"></vue-qrcode>
                                    
                            </div>
                             <p id="code" class="text-center"
                                    :class="{'long-code': campaign.serial.length > 12, 'serial-expire' : campaign.serial === 'XXXXXXX'}">
                                    {{campaign.serial === 'XXXXXXX' ? 'XXXXXXX' : campaign.serial}}</p>
                        </div>
                    </div>
                    <!--Not show code-->
                    <div class="serial-block"
                        v-if="!objSerialCode.isShowCode">
                        <div class="serial-wrapper">
                            <p class="serial-privilege-message"
                                v-html="cleanMessage(objSerialMessage.strMessage)"></p>
                        </div>

                    </div>
                </div>
                <!--Timer-->
                <div class="modal-base-footer">
                    <div class="serial-block">
                        <div class="serial-wrapper"
                            v-if="objTimer.isShowTimer">
                            <p id="serial_expire">
                                <span id="serial_expire_txt">{{lblSerial.expire_in}}</span>
                                <span id="serial_expire_time" :class="{'serial-expired': objTimer.isExpired}">{{objTimer.strTimeLeft}}</span></p>
                        </div>
                        <!-- <div class="serial-wrapper">
                            <p id="serial_redeem_on">{{getRedeemDate(campaign.redeemDate)}}</p>
                        </div> -->
                        <div class="serial-logo">
                            <!-- <img src="../../assets/bzbslogo/logo_bz.png" /> -->
                        </div>
                    </div>
                </div>

                <div class="btn-redeem">
                    <button class="btn-black" @click="closeSerialModal()">ปิด</button>
                </div>
            </div>
        </b-modal>

        <b-modal
            id="privilege_modal"
            modal-class=""
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <p id="headline">{{objSerialMessage.strHeadline}}</p>
                </div>
                <div class="modal-base-body">
                    <div class="serial-block">
                        <div class="serial-wrapper"
                            v-if="objSerialMessage.strMessageType === 'privilege'">
                            <p class="serial-privilege-message"
                                v-html="cleanMessage(this.objSerialMessage.strMessage)"></p>
                            <p class="serial-privilege-message"
                                v-if="campaign.derivered">{{lblSerial.delivery}}</p>
                        </div>
                        <div class="serial-wrapper"
                            v-if="objSerialMessage.strMessageType === 'delivery'">
                            <p id="serial_draw_delivery" class="serial-privilege-message"
                                v-html="cleanMessage(this.objSerialMessage.strMessage)"></p>
                        </div>
                        <div class="serial-logo">
                            <img src="../../assets/bzbslogo/buzzebees-logo-dark.svg" />
                        </div>
                    </div>
                </div>
                <div class="modal-base-footer">
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Vue from 'vue';
import Util from '@/helper/Utility.js';
import Moment from 'moment';
import Locale from '@/helper/locale/locale.js';
import VueBarcode from '@chenfengyuan/vue-barcode'; // https://github.com/fengyuanchen/vue-barcode/blob/master/README.md
import VueQrcode from '@chenfengyuan/vue-qrcode'; // https://github.com/fengyuanchen/vue-qrcode
import { TrackingService } from "@/helper/TrackingHelper.js";

/**
 * Property
 * @property {object} lbl (required) Text for component.
 * @property {object} busSerialModal (required) Modal Controller.
 * Event
 * @event clickChangeTab Change serial code type.
 * Method
 * @method initialSerialModal Setup serial modal with campaign.
 * @method closeSerialModal Stop interval and close modal.
 * Interval
 * @method startInterval Start serial interval.
 * @method stopInterval Stop serial interval.
 * @method serialExpired Set serial modal to expired state.
 * @method initialSerialTimer Setup time information and start interval.
 * @method timeFormatter Format timestamp to count down timer.
 * Utilities
 * @method cleanMessage Replace \n to <br/>
 * @method getRedeemDate Convert time stamp to readable format.
 * @method getDrawMessage Create message for campaign type draw.
 */
export default {
    name: 'SerialModal',
    components: {
        VueBarcode,
        VueQrcode
    },
    props: {
        lbl: Object,
        busSerialModal: Object
    },
    data: function() {
        return {
            campaign: {},
            lblDate: {},
            lblSerial: {},

            interval: null,
            isTabLock: false,
            isRenderComplete: false,
            strSerialType: 'serial', //serial,privilege
            objSerialMessage: {
                strHeadline: '',
                strMessage: '',
                strMessageType: '',
            },
            objSerialCode: {
                isShowCode: true,
                strCodeType: '', //CODE_128,QR_CODE,CODE
            },
            objTimer: {
                isExpired: false,
                isRunning: false,
                isShowTimer: false,
                numCurrentDate: '',
                numExpireDate: '',
                numExpireIn: 0,
                numOriginalDate: 0,
                strTimeLeft: ''
            },
            objBarcodeConfig: {
                height: 50,
                displayValue: true,
                lineColor: '#000000'
            },
            objQrCodeConfig: {
                width: 150
            },
            
            tracking: new TrackingService(this),
        };
    },
    mounted: function() {
        console.log("serialmodal");
        this.campaign.serial = "XXXXXXX";
        this.objSerialCode.strCodeType = "QR_CODE"
        this.lblDate = this.lbl.date;
        this.lblSerial = this.lbl.serial;
        this.busSerialModal.$on('showSerialModal', this.initialSerialModal);
        this.busSerialModal.$on('hideSerialModal', this.closeSerialModal);
        console.log("Serial");
    },
    methods: {
        //Event
        clickChangeTab: function(strCurrentTab) {
            if (this.isTabLock) return;

            this.objSerialCode.strCodeType = strCurrentTab;
        },
        //End Event
        //Function
        initialSerialModal: function(campaign) {
            this.campaign = Util.normalObject(campaign);
            console.log(this.campaign.serial)
            //Clear interval
            if(this.interval)
                this.stopInterval();

            if (this.campaign.delivered === true ||
                this.campaign.type === Vue.CampaignType.Draw)
                this.strSerialType = 'draw_or_delivery';

            //Initial modal type
            switch (this.strSerialType) {
                case 'serial':
                    //Initial serial tab
                    // switch (this.campaign.barcode) {
                    //     case 'CODE_128':
                    //         this.objSerialCode.strCodeType = 'CODE_128';
                    //         break;
                    //     case 'QR_CODE':
                    //         this.objSerialCode.strCodeType = 'QR_CODE';
                    //         break;
                    //     default:
                    //         if (this.campaign.barcode.toLowerCase() === 'none' &&
                    //             this.campaign.privilegeMessage)
                    //             this.objSerialCode.isShowCode = false;

                    //         this.objSerialCode.strCodeType = 'CODE';
                    //         break;
                    // }

                    // //Set privilege message fonmat
                    // if (this.campaign.privilegeMessageFormat &&
                    //     this.campaign.privilegeMessageFormat.toLowerCase() === 'html') {
                    //     if (this.campaign.privilegeMessage)
                    //         this.objSerialMessage.strMessage = this.campaign.privilegeMessage;
                    // } else {
                    //     if (this.campaign.privilegeMessage)
                    //         this.objSerialMessage.strMessage = this.campaign.privilegeMessage;
                    //     else
                    //         this.objSerialMessage.strMessage = this.lblSerial.show_code_at_shop;
                    // }

                    //Set isShowTimer
                    //this.initialSerialTimer();

                    this.$bvModal.show('serial_modal');
                    break;
                case 'draw_or_delivery':
                    if(this.campaign.privilegeMessage) {
                        this.objSerialMessage.strMessage = this.campaign.privilegeMessage;
                        this.objSerialMessage.strMessageType = 'privilege';
                    } else {
                        if(this.campaign.delivered === true) {
                            this.objSerialMessage.strMessage = this.lblSerial.delivery;
                            this.objSerialMessage.strMessageType = 'delivery';
                        }

                        if(this.campaign.type === Vue.CampaignType.Draw) {
                            this.objSerialMessage.strMessage = this.getDrawMessage(this.lblSerial.draw);
                            this.objSerialMessage.strMessageType = 'privilege';
                        }
                    }

                    this.$bvModal.show('privilege_modal');
                    break;
            }
        },
        closeSerialModal: function() {
            
            this.tracking.event("campaign_detail", "click_close_code_campaign", this.campaign.id+"|"+this.campaign.name);
            switch(this.strSerialType) {
                case 'serial':
                    this.stopInterval();
                    this.$bvModal.hide('serial_modal');
                    break;
                case 'draw_or_delivery':
                    this.$bvModal.hide('privilege_modal');
                    break;
            }
        },
        //Timer
        startInterval: function() {
            var self = this;
            this.timeFormatter(false, false, ':');
            this.interval = setInterval(function () {
                self.timeFormatter(false, false, ':');
            }, 1000);
        },
        stopInterval: function() {
            clearInterval(this.interval);
        },
        serialExpired: function() {
            this.objSerialCode.strCodeType = 'CODE';
            this.isTabLock = true;
            this.objTimer.isExpired = true;
            this.objTimer.isRunning = false;
            this.campaign.serial = "XXXXXXX";
            this.campaign.expireIn = -1;

            this.stopInterval();

            this.$emit('serialExpired', {});
        },
        initialSerialTimer: function () {
            if (this.campaign.expireIn) {
                this.objTimer.isShowTimer = true;
                this.objTimer.numCurrentDate = this.campaign.currentDate;
                this.objTimer.numOriginalDate = this.campaign.currentDate;
                this.objTimer.numExpireDate = this.campaign.currentDate + this.campaign.expireIn
                this.objTimer.numExpireIn = this.campaign.expireIn;
                this.startInterval();
            }
        },
        timeFormatter: function(isShowDay, isShowHour, strSeparator) {
            var numTimeDiff = Moment.unix(this.objTimer.numExpireDate) - Moment.unix(this.objTimer.numCurrentDate);
            //Timer Expired
            if(numTimeDiff <= 0) {
                numTimeDiff = 0;
                this.serialExpired();
            }

            //Add 1 second to current date.
            this.objTimer.numCurrentDate++;

            //Calculate day.
            var numDayDiff = Math.floor(numTimeDiff / 1000 / 60 / 60 / 24);
            var haveDay = parseInt(numDayDiff) <= 0 ? false : true;
            if(isShowDay)
                numTimeDiff -= numDayDiff * 1000 * 60 * 60 * 24;

            //Calculate hour.
            var numHourDiff = Math.floor(numTimeDiff / 1000 / 60 / 60);
            var haveHour = parseInt(numHourDiff) <= 0 ? false : true;
            if (isShowHour)
                numTimeDiff -= numHourDiff * 1000 * 60 * 60;

            if (numHourDiff <= 9)
                numHourDiff = "0" + numHourDiff;

            //Calculate minute.
            var numMinuteDiff = Math.floor(numTimeDiff / 1000 / 60);
            var haveMinute = parseInt(numMinuteDiff) <= 0 ? false : true;
            numTimeDiff -= numMinuteDiff * 1000 * 60;

            if (numMinuteDiff <= 9)
                numMinuteDiff = "0" + numMinuteDiff;

            //Calculate second.
            var numSecondDiff = "" + Math.floor(numTimeDiff / 1000);
            var haveSecond = parseInt(numSecondDiff) <= 0 ? false : true;
            if (numSecondDiff <= 9)
                numSecondDiff = "0" + numSecondDiff;

            var strTimeLeft = '';
            if (isShowDay) {
                if (haveDay)
                    strTimeLeft += numDayDiff + strSeparator;
                else
                    strTimeLeft += '00' + strSeparator;
            }

            if (isShowHour) {
                if (haveHour)
                    strTimeLeft += numHourDiff + strSeparator;
                else
                    strTimeLeft += '00' + strSeparator;
            }

            //Always show minute.
            if (haveMinute)
                strTimeLeft += numMinuteDiff + strSeparator;
            else
                strTimeLeft += '00' + strSeparator;

            //Always show second.
            if (haveSecond)
                strTimeLeft += numSecondDiff;
            else
                strTimeLeft += '00';

            this.objTimer.strTimeLeft = strTimeLeft;
        },
        //Utility
        cleanMessage: function (message) {
            return Util.newLineToBr(message);
        },
        getRedeemDate: function (redeemDate) {
            if (!redeemDate) return;

            var message = this.lblSerial.redeem_on;
            var result = Moment.unix(redeemDate).utc();
            var year = Moment.unix(redeemDate).utc().format('YYYY');
            if (Locale.getLocaleCode() === 1054) year = result.get('year') + 543;

            var monthString = this.lblDate.month_short[result.format('M') - 1];
            var strDate = result.format('DD') + " " + monthString + " " + year
                        + ' | ' + result.format('HH:mm');

            return Util.stringFormat(message, strDate);
        },
        getDrawMessage: function (message) {
            var expireDate = this.campaign.expireDate;
            var result = Moment.unix(expireDate).utc();
            var year = Moment.unix(expireDate).utc().format('YYYY');
            if (Locale.getLocaleCode() === 1054) year = result.get('year') + 543;

            var monthString = this.lblDate.month_short[result.format('M') - 1];
            var strDate = result.format('DD') + " " + monthString + " " + year
                        + ' | ' + result.format('HH:mm');

            return Util.stringFormat(message, strDate);
        }
    }
};
</script>

<style lang="scss">
    @import "@/style/base/base.scss";

    .img-campaign {
        margin: 20px 50px;

        img {
            -webkit-box-shadow: 0px 0px 15px 1px rgba(153,153,153,1);
            -moz-box-shadow: 0px 0px 15px 1px rgba(153,153,153,1);
            box-shadow: 0px 0px 15px 1px rgba(153,153,153,1);
        }
    }

    .content-header {
        text-align: center;
        font-size: 1.2rem;
        margin-bottom: 20px;
    }

    .privilege-message {

        margin-top: 20px;
        text-align: center;
        font-size: 1rem;
        
    }

    .serial-block {
        width: 100%;

        .serial-wrapper {
            width: 100%;

            .serial-privilege-message {
                width: 100%;
                font-size: 1rem;
                text-align: center;
            }

            #serial_draw_delivery {
                margin-top: 10px;
            }

            #serial_expire {
                text-align: center;
            }

            #serial_redeem_on {
                text-align: center;
            }
        }

        .serial-logo {
            width: 100%;
            margin-bottom: 30px;
            img {
                display: block;
                margin: auto;
                width: 90px;
                margin-top: 20px;
            }
        }
        
        .serial-tab-qr { 
            display: inline-block;
            width: calc(100% / 3);
            padding: 0;
            white-space: normal;
            position: relative;
            width: 100%;
            text-align: center;
                .qr {
                    color: #000 ;
                    border-bottom: 2px solid #000;
                }
        }
        #serial_tab_wrapper {
            font-size: 0;
            list-style: none;
            white-space: nowrap;

            .serial-tab {
                display: inline-block;
                width: calc(100% / 3);
                padding: 0;
                white-space: normal;
                font-size: 0;
                position: relative;

                &:nth-child(2) {
                    margin-left: -1px;
                    margin-right: -1px;
                }

                .serial-tab-lbl {
                    position: relative;
                    display: block;
                    padding: 10px;
                    font-size: 1rem;
                    font-weight: bold;
                    text-align: center;
                    text-decoration: none;
                    line-height: 1;
                    color: #989898;
                    border-bottom: 2px solid #989898;
                    cursor: pointer;
                    margin-left: 3px;
                    margin-right: 3px;


                    @media only screen and (max-width: 380px) {
                        font-size: 0.7rem;
                    }

                    &:hover {
                        color: #000;
                        border-bottom: 2px solid #000;
                    }

                    &.active {
                        color: #000;
                        border-bottom: 2px solid #000;
                        &::before {
                            background: wheat;
                            width: 65%;
                            margin: 0 auto;
                            height: 11px;
                            content: "";
                            display: block;
                            position: absolute;
                            left: 0;
                            right: 0;
                            bottom: 8px;
                            z-index: -1;
                        }
                    }
                }
                .tab-active {
                    color: #000 ;
                    border-bottom: 2px solid #000;
                }
            }
        }

        #serial_code_wrapper {
            .serial-code {
                @extend %display-flex;
                width: 100%;
                min-height: 150px;

                #code {
                    font-size: 1.5rem;
                    font-weight: bold;
                }

                #code, #barcode, #qrcode {
                    margin: auto;
                }
            }
        }
    }
</style>
